import React, { useMemo } from 'react';

import DatePicker from 'components/DatePicker';
import filterIntervalsFromDate from 'helper/Shared/filterIntervalsFromDate';
import sortedDatesAsIntervals from 'helper/Shared/sortedDatesAsIntervals';
import useClassicComparatorDates from 'utils/hooks/meteorology/classicComparator/useClassicComparatorDates';

export default function PeriodSection() {
  const {
    possibleIntervals,
    initialDate,
    setInitialDate,
    finalDate,
    setFinalDate,
  } = useClassicComparatorDates();

  const availableIntervals = useMemo(
    () => sortedDatesAsIntervals(possibleIntervals),
    [possibleIntervals],
  );
  const finalDateIntervals = useMemo(
    () => filterIntervalsFromDate(availableIntervals, initialDate),
    [availableIntervals, initialDate],
  );

  return (
    <div className="cc-mobile-period-section">
      <div className="cc-mobile-period-field">
        <span className="cc-mobile-period-label">Data inicial</span>
        <DatePicker
          className="form-control"
          placeholderText="Data inicial"
          selected={initialDate}
          onChange={setInitialDate}
          includeDateIntervals={availableIntervals}
        />
      </div>

      <div className="cc-mobile-period-field">
        <span className="cc-mobile-period-label">Data final</span>
        <DatePicker
          className="form-control"
          placeholderText="Data final"
          selected={finalDate}
          onChange={setFinalDate}
          includeDateIntervals={finalDateIntervals}
        />
      </div>
    </div>
  );
}
